import React from "react";
import { Capabilities } from "../../clients/graphqlTypes.js";
import { Restricted, RestrictedWithDebug } from "./Restricted.js";
import { useUserData } from "./useUserData.js";

interface Props
  extends Omit<React.ComponentProps<typeof Restricted>, "isRestricted"> {
  capability: Capabilities;
}

interface AnyCapabilitiesProps
  extends Omit<React.ComponentProps<typeof Restricted>, "isRestricted"> {
  capabilities: Capabilities[];
}

export const RestrictedByCapability = ({ capability, ...props }: Props) => {
  const { hasCapability } = useUserData();

  const isCapable = hasCapability(capability);

  return <Restricted isRestricted={!isCapable} {...props} />;
};

export const RestrictedByCapabilityWithDebug = ({
  capability,
  children,
  ...props
}: Props) => {
  const { hasCapability } = useUserData();

  const isCapable = hasCapability(capability);

  return (
    <RestrictedWithDebug
      {...props}
      isRestricted={!isCapable}
      debugLabel={`Capability: ${capability}`}
      debugColor={"#FFA500"}
    >
      {children}
    </RestrictedWithDebug>
  );
};

export const RestrictedByAnyCapabilityWithDebug = ({
  capabilities,
  children,
  ...props
}: AnyCapabilitiesProps) => {
  const { hasCapability } = useUserData();

  const isCapable = capabilities.some(cap => hasCapability(cap));

  return (
    <RestrictedWithDebug
      {...props}
      isRestricted={!isCapable}
      debugLabel={`Any capability: ${capabilities.join(", ")}`}
      debugColor={"#FFA500"}
    >
      {children}
    </RestrictedWithDebug>
  );
};
